import "./OurWork.module.css";
import Header from "@/reusable_sections/Header";
import TheWorkInMotion from "./sections/TheWorkInMotion";
import TheConversionFramework from "./sections/TheConversionFramework";
import StoriesOfCareAndChange from "./sections/StoriesOfCareAndChange";
import FooterInfo from "@/reusable_sections/Footer";
export default function OurWorkPage() {
  return <div className="bg-background text-foreground">
      <Header />
      <main>
        <TheWorkInMotion />
        <TheConversionFramework />
        <StoriesOfCareAndChange />
      </main>
      <FooterInfo />
    </div>;
}